(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-parallax"] && !Shopify.designMode) return;
  try {
    
  const COLLECTION_LIST_PARALLAX_MEDIA = window.matchMedia('(min-width: 990px)');

  function getCollectionListParallaxScrollTarget() {
    if (COLLECTION_LIST_PARALLAX_MEDIA.matches) {
      return document.querySelector('.page-wrapper') ?? window;
    }

    return window;
  }

  class CollectionListParallax extends HTMLElement {
    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      document.addEventListener('shopify:section:load', this.onSectionLoad);
      COLLECTION_LIST_PARALLAX_MEDIA.addEventListener('change', this.onMediaChange);
      this.initParallax();
    }

    disconnectedCallback() {
      this.teardownParallax();
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      COLLECTION_LIST_PARALLAX_MEDIA.removeEventListener('change', this.onMediaChange);
      this.resizeObserver?.disconnect();
    }

    onSectionLoad(event) {
      if (event.detail?.sectionId === this.dataset.sectionId) {
        this.initParallax();
      }
    }

    onMediaChange() {
      this.initParallax();
    }

    initParallax() {
      this.teardownParallax();

      this.styleTarget =
        this.parentElement?.matches('.collection-list-parallax-host') ? this.parentElement : this;
      this.header =
        this.parentElement?.querySelector('.collection-list-parallax__header') ??
        this.querySelector('.collection-list-parallax__header');
      this.cardsViewport = this.querySelector('[data-parallax-cards-viewport]');
      this.cardsStage = this.querySelector('[data-parallax-cards-stage]');
      this.grid = this.querySelector('[data-parallax-cards]');
      this.cards = Array.from(this.querySelectorAll('.collection-list-parallax__card'));
      this.parallaxEnabled = this.dataset.parallaxHeader === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intensity =
        parseFloat(
          getComputedStyle(this.styleTarget).getPropertyValue('--collection-list-parallax-parallax-intensity').trim()
        ) || 1;

      if (!this.parallaxEnabled || this.reducedMotion) {
        this.resetParallaxStyles(true);
        return;
      }

      this.resizeObserver?.disconnect();
      this.resizeFrame = null;
      this.cardsHeight = 0;
      this.resizeObserver = new ResizeObserver(() => {
        if (this.resizeFrame) {
          return;
        }

        this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.measureHeights();
          this.updateParallax();
        });
      });

      if (this.grid) {
        this.resizeObserver.observe(this.grid);
      }

      this.scrollTarget = getCollectionListParallaxScrollTarget();
      this.ticking = false;
      this.scrollTarget.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.measureHeights();
      this.updateParallax();
    }

    measureHeights() {
      if (!this.parallaxEnabled || !this.cardsStage) {
        return 0;
      }

      const cards = this.cardsStage.querySelectorAll('.collection-list-parallax__card');
      const gridStyles = this.grid ? getComputedStyle(this.grid) : null;
      const gridGap = gridStyles ? parseFloat(gridStyles.rowGap || gridStyles.gap) || 0 : 0;
      let cardsHeight = 0;

      cards.forEach((card, index) => {
        cardsHeight += card.offsetHeight;
        if (index > 0) {
          cardsHeight += gridGap;
        }
      });

      if (this.grid?.offsetHeight > cardsHeight) {
        cardsHeight = this.grid.offsetHeight;
      }

      this.cardsHeight = cardsHeight;

      const headerHeight = this.header?.offsetHeight || 0;
      const scrollRunway = cardsHeight * 0.25 * this.intensity;

      this.styleTarget.style.setProperty('--collection-list-parallax-cards-height', `${cardsHeight}px`);
      this.styleTarget.style.setProperty('--collection-list-parallax-header-height', `${headerHeight}px`);
      this.styleTarget.style.setProperty('--collection-list-parallax-scroll-runway', `${scrollRunway}px`);
      this.setViewportHeight(cardsHeight);

      return cardsHeight;
    }

    setViewportClip(clip) {
      const clipValue = Math.max(0, Math.round(clip));
      this.styleTarget.style.setProperty('--collection-list-parallax-viewport-clip', `${clipValue}px`);
    }

    setViewportHeight(height) {
      if (!this.cardsViewport) {
        return;
      }

      const viewportHeight = Math.max(0, Math.round(height));
      this.styleTarget.style.setProperty('--collection-list-parallax-viewport-height', `${viewportHeight}px`);
    }

    teardownParallax() {
      if (this.scrollTarget) {
        this.scrollTarget.removeEventListener('scroll', this.onScroll);
        this.scrollTarget = null;
      }

      window.removeEventListener('resize', this.onResize);
      if (this.resizeFrame) {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
      }
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
      this.resetParallaxStyles(true);
    }

    resetParallaxStyles(clearVariables = false) {
      const styleTarget =
        this.styleTarget ??
        (this.parentElement?.matches('.collection-list-parallax-host') ? this.parentElement : this);

      if (clearVariables && styleTarget) {
        styleTarget.style.removeProperty('--collection-list-parallax-cards-height');
        styleTarget.style.removeProperty('--collection-list-parallax-header-height');
        styleTarget.style.removeProperty('--collection-list-parallax-scroll-runway');
        styleTarget.style.removeProperty('--collection-list-parallax-viewport-height');
        styleTarget.style.removeProperty('--collection-list-parallax-viewport-clip');
      }

      this.cardsHeight = 0;

      if (this.header) {
        this.header.style.transform = '';
      }

      if (this.cardsStage) {
        this.cardsStage.style.transform = '';
        this.cardsStage.classList.remove('is-parallax-active');
      }

      this.cards?.forEach((card) => {
        card.style.removeProperty('--collection-list-parallax-card-current-rotate');
      });
    }

    isSectionInView(sectionRect, viewportHeight) {
      return sectionRect.bottom > 0 && sectionRect.top < viewportHeight;
    }

    updateCardRotations() {
      if (!this.cards?.length) {
        return;
      }

      const foldMid = window.innerHeight / 2;

      this.cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();

        if (cardRect.top <= foldMid) {
          card.style.setProperty('--collection-list-parallax-card-current-rotate', '0deg');
        } else {
          card.style.removeProperty('--collection-list-parallax-card-current-rotate');
        }
      });
    }

    onResize() {
      this.measureHeights();
      this.updateParallax();
    }

    onScroll() {
      if (!this.parallaxEnabled || this.reducedMotion) {
        return;
      }

      if (this.ticking) {
        return;
      }

      this.ticking = true;
      requestAnimationFrame(() => {
        this.updateParallax();
        this.ticking = false;
      });
    }

    updateParallax() {
      if (!this.parallaxEnabled || !this.cardsStage) {
        return;
      }

      let cardsHeight = this.cardsHeight || 0;
      if (cardsHeight <= 0) {
        cardsHeight = this.measureHeights();
      }

      if (cardsHeight <= 0) {
        return;
      }

      const sectionRect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const isMobile = !COLLECTION_LIST_PARALLAX_MEDIA.matches;

      if (!this.isSectionInView(sectionRect, viewportHeight)) {
        this.cardsStage.style.transform = '';
        this.cardsStage.classList.remove('is-parallax-active');
        this.setViewportClip(0);
        this.updateCardRotations();
        return;
      }

      const gapValue =
        parseFloat(getComputedStyle(this.styleTarget).getPropertyValue('--collection-list-parallax-gap').trim()) || 48;
      const stickyTop = this.header ? parseFloat(getComputedStyle(this.header).top) || 48 : 48;
      const headerHeight = this.header?.offsetHeight || 0;
      const maxLift = cardsHeight * 0.25 * this.intensity;
      const isPinned =
        sectionRect.top <= stickyTop + 0.5 &&
        sectionRect.bottom > stickyTop + headerHeight + gapValue;

      if (!isPinned || maxLift <= 0) {
        this.cardsStage.style.transform = '';
        this.cardsStage.classList.remove('is-parallax-active');
        this.setViewportClip(0);
        this.updateCardRotations();
        return;
      }

      const scrolledWhilePinned = Math.max(0, stickyTop - sectionRect.top);
      const scrollRunway = Math.max(maxLift, viewportHeight * (isMobile ? 0.25 : 0.35));
      const firstFoldEnd = Math.min(
        viewportHeight * (isMobile ? 0.2 : 0.35),
        scrollRunway * (isMobile ? 0.15 : 0.25)
      );

      let translateY = 0;
      if (scrolledWhilePinned > firstFoldEnd) {
        const parallaxProgress = Math.min(
          1,
          (scrolledWhilePinned - firstFoldEnd) / Math.max(scrollRunway - firstFoldEnd, 1)
        );
        translateY = -parallaxProgress * maxLift;
      }

      this.cardsStage.classList.add('is-parallax-active');
      this.cardsStage.style.transform = `translate3d(0, ${translateY}px, 0)`;
      this.setViewportClip(-translateY);
      this.updateCardRotations();
    }
  }

  if (!customElements.get('collection-list-parallax')) {
    customElements.define('collection-list-parallax', CollectionListParallax);
  } else {
    document.querySelectorAll('collection-list-parallax').forEach((element) => {
      if (element.initParallax) {
        element.initParallax();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-with-content"] && !Shopify.designMode) return;
  try {
    
  class CollectionListContent extends HTMLElement {
    connectedCallback() {
      this.bindCardButtons();
    }

    get items() {
      return this.querySelectorAll('.collection-list-content__carousel .resource-list__item');
    }

    bindCardButtons() {
      if (!this.hasAttribute('data-link-button')) return;

      this.items.forEach((item) => {
        const url = item.getAttribute('data-collection-url');
        const title = item.getAttribute('data-collection-title');
        if (!url) return;

        item
          .querySelectorAll('a.button, a.button-secondary, a.button-unstyled, a.button-custom')
          .forEach((button) => {
            this.applyCollectionToButton(button, url, title);
          });
      });
    }

    applyCollectionToButton(button, url, title) {
      button.setAttribute('href', url);
      button.removeAttribute('role');
      button.removeAttribute('aria-disabled');

      if (!this.hasAttribute('data-update-button-label') || !title) return;

      const caret = button.querySelector('.icon-caret');
      const textNode = [...button.childNodes].find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
      );

      if (textNode) {
        textNode.textContent = ` ${title} `;
        return;
      }

      if (caret) {
        button.insertBefore(document.createTextNode(`${title} `), caret);
        return;
      }

      button.textContent = title;
    }
  }

  if (!customElements.get('collection-list-content')) {
    customElements.define('collection-list-content', CollectionListContent);
  } else {
    document.querySelectorAll('collection-list-content').forEach((element) => {
      if (element.connectedCallback) element.connectedCallback();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllers = new WeakMap();
    const SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');

    function getHeroScrollTarget() {
      if (SQUEEZE_QUERY.matches) {
        return document.querySelector('.page-wrapper') ?? window;
      }

      return window;
    }

    /**
     * @param {EventTarget | null} target
     */
    function getHeroScrollTop(target) {
      if (!target || target === window || target === document) {
        return window.scrollY || document.documentElement.scrollTop || 0;
      }

      if (target instanceof Element) {
        return target.scrollTop || 0;
      }

      return 0;
    }

    class HeroMediaExpand {
      /** @param {HTMLElement} el */
      constructor(el) {
        this.el = el;
        this.mediaGrid = el.querySelector('.hero__media-grid');
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);
        this.ticking = false;
        this.completed = false;
        this.scrollTarget = null;
        this.minScale =
          parseFloat(getComputedStyle(el).getPropertyValue('--hero-media-min-scale')) || 0.2;
      }

      getScrollDistance() {
        const raw = getComputedStyle(this.el).getPropertyValue('--hero-media-expand-distance').trim();
        const vhMatch = raw.match(/^([\d.]+)vh$/i);

        if (vhMatch) {
          return (parseFloat(vhMatch[1]) / 100) * window.innerHeight;
        }

        const px = parseFloat(raw);
        return Number.isFinite(px) && px > 0 ? px : window.innerHeight * 0.5;
      }

      start() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.complete();
          return;
        }

        this.bindScrollTarget();
        window.addEventListener('resize', this.onResize, { passive: true });
        SQUEEZE_QUERY.addEventListener('change', this.onMediaChange);
        this.update();
      }

      stop() {
        this.unbindScrollTarget();
        window.removeEventListener('resize', this.onResize);
        SQUEEZE_QUERY.removeEventListener('change', this.onMediaChange);
      }

      bindScrollTarget() {
        this.unbindScrollTarget();
        this.scrollTarget = getHeroScrollTarget();
        this.scrollTarget.addEventListener('scroll', this.onScroll, { passive: true });
      }

      unbindScrollTarget() {
        this.scrollTarget?.removeEventListener('scroll', this.onScroll);
        this.scrollTarget = null;
      }

      onMediaChange() {
        if (this.completed) return;
        this.bindScrollTarget();
        this.update();
      }

      onResize() {
        if (this.completed) return;
        this.onScroll();
      }

      onScroll() {
        if (this.ticking || this.completed) return;

        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        const scrollDistance = this.getScrollDistance();
        const progress = Math.min(1, Math.max(0, getHeroScrollTop(this.scrollTarget) / scrollDistance));
        const scale = this.minScale + (1 - this.minScale) * progress;

        this.setScale(scale);

        if (progress >= 1) {
          this.complete();
        }
      }

      /**
       * @param {number} scale
       */
      setScale(scale) {
        const value = String(scale);
        this.el.style.setProperty('--hero-media-scale', value);
        this.mediaGrid?.style.setProperty('--hero-media-scale', value);
      }

      complete() {
        this.completed = true;
        this.setScale(1);
        this.el.setAttribute('data-media-expanded', '');
        this.stop();
      }
    }

    /**
     * @param {ParentNode} [root]
     */
    function init(root = document) {
      root.querySelectorAll('[data-expand-media-on-scroll]').forEach((el) => {
        if (!(el instanceof HTMLElement) || controllers.has(el)) return;

        const controller = new HeroMediaExpand(el);
        controllers.set(el, controller);
        controller.start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) {
        init(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-with-sidebar"] && !Shopify.designMode) return;
  try {
    
  class RichTextWithSidebar extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId || '';
      this.content = this.querySelector('.rich-text-with-sidebar__content');
      this.onLabelClick = this.onLabelClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.unlockActive = this.unlockActive.bind(this);

      if (!this.content) return;

      this.assignHeadingIds();
      this.labels = Array.from(this.querySelectorAll('.rich-text-with-sidebar__label[data-heading-handle]')).filter(
        (label) => !label.classList.contains('hidden')
      );
      const labelHandles = new Set(this.labels.map((label) => label.dataset.headingHandle));
      const seenHandles = new Set();
      this.headings = Array.from(this.content.querySelectorAll('[data-heading-handle]')).filter((heading) => {
        const handle = heading.dataset.headingHandle;
        if (!handle || !labelHandles.has(handle) || seenHandles.has(handle)) return false;
        seenHandles.add(handle);
        return true;
      });

      this.bindLabels();
      this.bindScroll();
      this.updateActiveFromScroll();
    }

    disconnectedCallback() {
      this.unbindScroll();
      this.labels?.forEach((label) => label.removeEventListener('click', this.onLabelClick));
    }

    handleize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    assignHeadingIds() {
      const prefix = `rtws-${this.sectionId}-`;

      this.content.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        if (heading.closest('.rich-text-with-sidebar__heading')) return;

        const handle = this.handleize(heading.textContent);
        if (!handle) return;

        heading.dataset.headingHandle = handle;
        if (!heading.id) heading.id = `${prefix}${handle}`;
      });
    }

    bindLabels() {
      this.labels.forEach((label) => label.addEventListener('click', this.onLabelClick));
    }

    bindScroll() {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    unbindScroll() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scrollend', this.unlockActive);
      cancelAnimationFrame(this.raf);
      clearTimeout(this.unlockTimer);
    }

    onScroll() {
      if (this.lockActive) return;
      if (this.raf) return;

      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.updateActiveFromScroll();
      });
    }

    onResize() {
      if (this.lockActive) return;
      this.updateActiveFromScroll();
    }

    getMarkerY() {
      const heading = this.headings[0];
      const scrollMargin = heading ? parseFloat(getComputedStyle(heading).scrollMarginTop) : NaN;
      if (Number.isFinite(scrollMargin) && scrollMargin > 0) return scrollMargin;

      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      return headerHeight + 24;
    }

    updateActiveFromScroll() {
      if (!this.headings.length) {
        if (this.labels[0]) this.setActive(this.labels[0].dataset.headingHandle);
        return;
      }

      const marker = this.getMarkerY() + 1;
      let activeHandle = this.headings[0].dataset.headingHandle;

      for (const heading of this.headings) {
        if (heading.getBoundingClientRect().top <= marker) {
          activeHandle = heading.dataset.headingHandle;
        } else {
          break;
        }
      }

      this.setActive(activeHandle);
    }

    onLabelClick(event) {
      const label = event.currentTarget;
      const handle = label.dataset.headingHandle;
      const target = this.headings.find((heading) => heading.dataset.headingHandle === handle);

      if (!target) return;

      event.preventDefault();
      this.lockActive = true;
      this.setActive(handle);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target.id) history.replaceState(null, '', `#${target.id}`);

      window.removeEventListener('scrollend', this.unlockActive);
      window.addEventListener('scrollend', this.unlockActive, { once: true });
      clearTimeout(this.unlockTimer);
      this.unlockTimer = setTimeout(this.unlockActive, 1000);
    }

    unlockActive() {
      clearTimeout(this.unlockTimer);
      window.removeEventListener('scrollend', this.unlockActive);
      this.lockActive = false;
      this.updateActiveFromScroll();
    }

    setActive(handle) {
      if (handle === this.activeHandle) return;
      this.activeHandle = handle;

      this.labels.forEach((label) => {
        const isActive = label.dataset.headingHandle === handle;
        label.classList.toggle('is-active', isActive);
        if (isActive) {
          label.setAttribute('aria-current', 'location');
        } else {
          label.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('rich-text-with-sidebar')) {
    customElements.define('rich-text-with-sidebar', RichTextWithSidebar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-heading-images"] && !Shopify.designMode) return;
  try {
    
  class ScrollHeadingImages extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.scroll-heading-images__item'));
      this.visuals = Array.from(this.querySelectorAll('.scroll-heading-images__visuals'));
      this.intersecting = new Map();
      this.scrollIndex = null;
      this.hoveredIndex = null;
      this.onItemEnter = this.onItemEnter.bind(this);
      this.onItemLeave = this.onItemLeave.bind(this);

      if (!this.items.length || !this.visuals.length) {
        return;
      }

      this.observer?.disconnect();
      this.unbindHover();
      this.sync();
      this.bindHover();

      if (!window.IntersectionObserver) {
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.intersecting.set(entry.target, entry);
          });

          const visibleEntries = Array.from(this.intersecting.values())
            .filter((entry) => entry.isIntersecting)
            .sort((entryA, entryB) => {
              const viewportCenter = window.innerHeight / 2;
              const distanceA = Math.abs(
                entryA.boundingClientRect.top + entryA.boundingClientRect.height / 2 - viewportCenter
              );
              const distanceB = Math.abs(
                entryB.boundingClientRect.top + entryB.boundingClientRect.height / 2 - viewportCenter
              );

              return distanceA - distanceB;
            });

          if (!visibleEntries.length) {
            return;
          }

          this.scrollIndex = visibleEntries[0]?.target?.dataset?.index ?? null;
          this.sync();
        },
        {
          threshold: [0, 0.25, 0.5, 0.75, 1],
          rootMargin: '-45% 0px -45% 0px',
        }
      );

      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersecting?.clear();
      this.unbindHover();
    }

    bindHover() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return;
      }

      this.items.forEach((item) => {
        item.addEventListener('mouseenter', this.onItemEnter);
        item.addEventListener('mouseleave', this.onItemLeave);
      });
    }

    unbindHover() {
      this.items?.forEach((item) => {
        item.removeEventListener('mouseenter', this.onItemEnter);
        item.removeEventListener('mouseleave', this.onItemLeave);
      });
    }

    onItemEnter(event) {
      this.hoveredIndex = event.currentTarget.dataset.index ?? null;
      this.sync();
    }

    onItemLeave() {
      this.hoveredIndex = null;
      this.sync();
    }

    sync() {
      this.items.forEach((item) => {
        const index = item.dataset.index;
        item.classList.toggle('is-active', index === this.scrollIndex);
        item.classList.toggle('is-hover', index === this.hoveredIndex);
      });

      this.visuals.forEach((visual) => {
        const index = visual.dataset.index;

        if (visual.dataset.scrollDisplay === 'false') {
          visual.classList.remove('is-active', 'is-hover');
          return;
        }

        visual.classList.toggle('is-active', index === this.scrollIndex && this.hoveredIndex == null);
        visual.classList.toggle('is-hover', index === this.hoveredIndex);
      });
    }
  }

  if (!customElements.get('scroll-heading-images')) {
    customElements.define('scroll-heading-images', ScrollHeadingImages);
  }

  } catch(e) { console.error(e); }
})();
})();
